import { render } from "./MSReflectionDisplayModal.vue?vue&type=template&id=644e7726&scoped=true"
import script from "./MSReflectionDisplayModal.vue?vue&type=script&lang=ts"
export * from "./MSReflectionDisplayModal.vue?vue&type=script&lang=ts"

import "./MSReflectionDisplayModal.vue?vue&type=style&index=0&id=644e7726&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-644e7726"

export default script